import { defineProperty as _defineProperty } from '../../../../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import { Grid, GridItem, Image } from '@deal/components';
import { usePathContext } from '../../../../../context/PathContext.js';
import classNames from 'classnames';
import PlainText from '../../../../../components/PlainText/index.js';
import styles from './styles.css.js';

var ImageTextBlocks = function ImageTextBlocks(_ref) {
  var blocks = _ref.blocks;
  var pathContext = usePathContext();
  var gridColumnSize = 12 / blocks.length;
  var isDefaultPlacement = pathContext.pathPlacement === 'default';
  return React.createElement(Grid, {
    rowGaps: true,
    className: classNames(styles.blockWrapper, _defineProperty({}, styles.placementDefault, isDefaultPlacement))
  }, blocks.map(function (block, idx) {
    var _classNames3;

    var _a, _b;

    return React.createElement(GridItem, {
      col: 2,
      mdCol: gridColumnSize,
      key: idx,
      className: classNames(styles.gridItem, _defineProperty({}, styles.placementDefault, isDefaultPlacement))
    }, React.createElement("div", {
      className: styles.block
    }, block.primaryImage && React.createElement("div", {
      className: classNames(styles.imageContainer, (_classNames3 = {}, _defineProperty(_classNames3, styles.singleImageContainer, blocks.length === 1), _defineProperty(_classNames3, styles.placementDefault, isDefaultPlacement), _classNames3))
    }, React.createElement(Image, {
      src: (_a = block.primaryImage) === null || _a === void 0 ? void 0 : _a.url,
      sizes: "(min-width: 64em) 25vw, (min-width: 52em) 33vw, (min-width: 40em) 50vw, 100vw",
      className: styles.image,
      htmlAttributes: {
        alt: (_b = block.titleText) === null || _b === void 0 ? void 0 : _b.plainText
      }
    })), block.titleText && React.createElement("div", {
      className: classNames(styles.blockHeader, _defineProperty({}, styles.placementDefault, isDefaultPlacement))
    }, React.createElement(PlainText, {
      plainTextEntry: block.titleText
    })), block.subTitleText && React.createElement("div", {
      className: classNames(styles.blockBody, _defineProperty({}, styles.placementDefault, isDefaultPlacement))
    }, React.createElement(PlainText, {
      plainTextEntry: block.subTitleText
    }))));
  }));
};

export default ImageTextBlocks;
//# sourceMappingURL=index.js.map
